import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/form/style";
import _Form from "antd/lib/form";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import "antd/lib/tabs/style";
import _Tabs from "antd/lib/tabs";
import "antd/lib/divider/style";
import _Divider from "antd/lib/divider";
import { jsxs as _jsxs } from "react/jsx-runtime";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/var/www/vhosts/voicebrief.app/httpdocs/next/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Spacer from 'components/commons/Spacer';
import UploadImage from 'components/commons/UploadImage';
import { cleanNulls, getFullName } from 'constants/helpers';
import { Notifications } from 'constants/Notifications';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import ServiceAuthentication from 'services/Auth';
import LocalStorage from 'services/LocalStorage';
import { useSessionUser } from 'store/hooks';

var UserPopover = function UserPopover() {
  var _useSessionUser = useSessionUser(),
      me = _useSessionUser.me,
      setMe = _useSessionUser.setMe,
      signOut = _useSessionUser.signOut;

  var _useState = useState(undefined),
      image = _useState[0],
      setImage = _useState[1];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState('info'),
      activeTab = _useState3[0],
      setActiveTab = _useState3[1];

  var router = useRouter(); // const { doLogout } = useLogOut()

  var changeImage = function changeImage(image) {
    setImage(image);
    updateUser(_objectSpread(_objectSpread({}, me), {}, {
      image: image
    }));
  };

  var updateUser = function updateUser(values) {
    console.log('Success:', values);
    setLoading(true); //debugger;
    //@ts-ignore

    var uuid = me.uuid,
        currImage = me.image;
    var newUser = cleanNulls(_objectSpread(_objectSpread({
      uuid: uuid
    }, values), {}, {
      image: values.image || image || currImage
    }));
    console.log('newUser', newUser);
    ServiceAuthentication.update({
      userUUID: me.uuid,
      data: newUser
    }).then(function (updatedUser) {
      setMe(updatedUser);
      LocalStorage.setItem('me', updatedUser);
      Notifications({
        message: 'User Updated!',
        description: ''
      });
      setActiveTab('info');
    })["finally"](function () {
      return setLoading(false);
    });
  };

  var onFinishFailed = function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
  };

  useEffect(function () {
    console.log('Effect UserPopover');
  }, []);
  return /*#__PURE__*/_jsx("div", {
    id: "userPopoverContent",
    children: /*#__PURE__*/_jsxs(_Tabs, {
      activeKey: activeTab,
      type: "line",
      children: [/*#__PURE__*/_jsxs(_Tabs.TabPane, {
        tab: "Info",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "doublePadded",
          children: [/*#__PURE__*/_jsx("div", {
            className: "userAvatarUpload",
            children: /*#__PURE__*/_jsx(UploadImage, {
              type: "circle",
              className: "briefImage bgCover ",
              uploadImage: image || (me === null || me === void 0 ? void 0 : me.image),
              onUpload: function onUpload(image) {
                changeImage(image);
              },
              enableCrop: true,
              aspect: 1 / 1
            })
          }), /*#__PURE__*/_jsx(Spacer, {
            margin: 10
          }), /*#__PURE__*/_jsx("div", {
            className: "userFullName",
            children: getFullName(me)
          }), /*#__PURE__*/_jsx("div", {
            className: "smallText",
            children: me === null || me === void 0 ? void 0 : me.email
          }), /*#__PURE__*/_jsx(Spacer, {
            margin: 10
          }), /*#__PURE__*/_jsx(_Button, {
            onClick: function onClick() {
              return setActiveTab('edit');
            },
            type: "default",
            children: "Manage your account"
          }), /*#__PURE__*/_jsx(Spacer, {
            margin: 10
          }), /*#__PURE__*/_jsx(Spacer, {
            margin: 20
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(_Divider, {
            style: {
              margin: 'auto'
            }
          }), /*#__PURE__*/_jsx("div", {
            className: "halfpadded",
            children: /*#__PURE__*/_jsx(_Button, {
              onClick: signOut,
              type: "link",
              children: "Log out"
            })
          })]
        })]
      }, "info"), /*#__PURE__*/_jsx(_Tabs.TabPane, {
        tab: "edit",
        children: /*#__PURE__*/_jsxs("div", {
          className: "doublePadded",
          children: [/*#__PURE__*/_jsx("div", {
            className: "userAvatarUpload",
            children: /*#__PURE__*/_jsx(UploadImage, {
              type: "circle",
              className: "briefImage bgCover ",
              uploadImage: image || (me === null || me === void 0 ? void 0 : me.image),
              onUpload: function onUpload(image) {
                changeImage(image);
              },
              enableCrop: true,
              aspect: 1 / 1
            })
          }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(_Form, {
            //{...layout}
            className: "userForm",
            name: "basic",
            layout: "horizontal",
            initialValues: me,
            onFinish: updateUser,
            onFinishFailed: onFinishFailed,
            children: [/*#__PURE__*/_jsx(_Form.Item, {
              className: "input inputMaterial",
              name: "firstName",
              label: "FirstName",
              rules: [{
                required: true,
                message: 'Please input your firstName!'
              }],
              children: /*#__PURE__*/_jsx(_Input, {
                placeholder: "firstName"
              })
            }), /*#__PURE__*/_jsx(_Form.Item, {
              className: "input inputMaterial",
              name: "lastName",
              label: "lastName",
              rules: [{
                required: true,
                message: 'Please input your lastName!'
              }],
              children: /*#__PURE__*/_jsx(_Input, {
                placeholder: "lastName"
              })
            }), /*#__PURE__*/_jsx(_Form.Item, {
              className: "input inputMaterial",
              name: "email",
              rules: [{
                message: 'Please input your email!'
              }],
              children: /*#__PURE__*/_jsx(_Input, {
                placeholder: "Email",
                disabled: true
              })
            }), /*#__PURE__*/_jsxs(_Space, {
              direction: "vertical",
              align: "center",
              children: [/*#__PURE__*/_jsx(_Button, {
                type: "primary",
                htmlType: "submit",
                loading: loading,
                children: "Update User"
              }), /*#__PURE__*/_jsx(_Button, {
                type: "link",
                onClick: function onClick() {
                  setActiveTab('info');
                },
                children: "Cancel"
              })]
            })]
          })]
        })
      }, "edit")]
    })
  });
};

export default UserPopover;